import { apiClient } from '@/api/apiClient';
import endpoints from './endpoints';

export default {
  getUserById: async (id) => await apiClient.get(endpoints.getById(id)),
  blockUserById: async (id) => await apiClient.post(endpoints.blockById(id)),
  unblockUserById: async (id) => await apiClient.delete(endpoints.blockById(id)),
  getUserRoles: async (id) => await apiClient.get(endpoints.userRoles(id)),
  updateUserRole: async ({ user_id, role_ids }) => await apiClient.put(endpoints.userRoles(user_id), { role_ids }),
};
